import { Imports } from '@gleamer/types';
import { DATE_LOCALE } from '../../../../utils/locale';

type ImportCounters = Imports.ImportCounters;

export function formatDateTime(value?: string | null): string {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString(DATE_LOCALE);
}

export function formatBytes(bytes?: number | null): string {
  if (bytes === null || bytes === undefined) {
    return '—';
  }
  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${unit === 0 ? value : value.toFixed(1)} ${units[unit]}`;
}

/**
 * The files by where they stand, each counted once. The orchestrator's counters overlap — `imported`
 * counts the exported files and the export errors too — so they are taken apart here.
 */
export function fileBreakdown(c: ImportCounters) {
  const waitingForExport = Math.max(0, c.imported - c.exported - c.exportErrors);
  const toDo = Math.max(0, c.files - c.imported - c.importErrors);
  return {
    exported: c.exported,
    waitingForExport,
    importErrors: c.importErrors,
    exportErrors: c.exportErrors,
    toDo,
    /** Exported to BigQuery: nothing left to do for them. */
    done: c.exported,
    errors: c.importErrors + c.exportErrors,
  };
}

/** The segments of a batch's or a line's progress bar, in the order the files move through them. */
export function progressSegments(c: ImportCounters) {
  const b = fileBreakdown(c);
  return [
    { label: 'Exported', value: b.exported, className: 'bg-dl-success' },
    { label: 'Waiting for BigQuery', value: b.waitingForExport, className: 'bg-dl-primary/40' },
    { label: 'Import errors', value: b.importErrors, className: 'bg-dl-danger' },
    { label: 'Export errors', value: b.exportErrors, className: 'bg-dl-warning' },
    { label: 'To do', value: b.toDo, className: 'bg-dl-faint' },
  ];
}
